import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { ShieldHeartIcon } from './icons/Icons';
export function GuaranteeSection() {
  return <section className="w-full bg-[#eef2e6] py-16 sm:py-20" data-id="element-91">
      <div className="mx-auto max-w-4xl px-5" data-id="element-92">
        <Reveal data-id="element-93">
          <div className="flex flex-col items-center gap-8 rounded-3xl border-2 border-dashed border-[#3f6b3a]/40 bg-white p-8 text-center shadow-sm sm:flex-row sm:p-10 sm:text-left" data-id="element-94">
            <motion.div animate={{
            rotate: [0, -4, 4, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative flex h-32 w-32 shrink-0 items-center justify-center rounded-full bg-[#3f6b3a] text-white shadow-lg" data-id="element-95">
              <span className="absolute inset-2 rounded-full border-2 border-dashed border-white/40" data-id="element-96" />
              <div className="flex flex-col items-center" data-id="element-97">
                <ShieldHeartIcon className="h-10 w-10" strokeWidth={1.8} data-id="element-98" />
                <span className="mt-1 font-display text-xs font-bold uppercase leading-tight tracking-wide" data-id="element-99">
                  7 Días
                </span>
              </div>
            </motion.div>

            <div data-id="element-100">
              <span className="inline-block rounded-full bg-[#3f6b3a]/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[#3f6b3a]" data-id="element-101">
                Garantía Cero Riesgos
              </span>
              <h2 className="mt-3 font-display text-2xl font-extrabold text-[#1f2a22] sm:text-3xl" data-id="element-102">
                Garantía de 7 Días “Fuego Apagado”
              </h2>
              <p className="mt-3 text-base leading-relaxed text-[#3d4a40]" data-id="element-103">
                Si en una semana no sientes una mejoría notable en tu digestión,
                envíame un email y te devuelvo tus{' '}
                <span className="font-semibold text-[#1f2a22]" data-id="element-104">$10.99</span>{' '}
                inmediatamente. Te quedas con el libro y los bonos. Así de
                seguro estoy de que esto funciona.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}